import BaseModule from '@/store/modules/base.module'
var baseModule = new BaseModule('presentation')

const state = {
  ...baseModule.state
}
const mutations = {
  ...baseModule.mutations
}
const actions = {
  ...baseModule.actions
  // updateStatus ({ commit, dispatch, getters }, {id, status}) {
  //   return dispatch('request', {
  //     settings: {
  //       url: getters.endpoint + '/' + id + '/status',
  //       data: { status },
  //       method: 'PATCH'
  //     },
  //     save: false,
  //     refresh: false
  //   })
  // },
}
const getters = {
  ...baseModule.getters
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/presentation.module.js